import { forwardRef } from 'react';
import styles from './StyledConstants.module.css';

type DivProps = React.ComponentPropsWithoutRef<'div'>;
type PProps = React.ComponentPropsWithoutRef<'p'>;
type ButtonProps = React.ComponentPropsWithoutRef<'button'>;

export const ReviewsContainer = ({ className, ...props }: DivProps) => (
  <div
    className={`${styles.reviewsContainer}${className ? ` ${className}` : ''}`}
    {...props}
  />
);

export const ScrollContainer = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={`${styles.scrollContainer}${className ? ` ${className}` : ''}`}
      {...props}
    />
  ),
);
ScrollContainer.displayName = 'ScrollContainer';

export const ReviewItem = ({ className, ...props }: DivProps) => (
  <div
    className={`${styles.reviewItem}${className ? ` ${className}` : ''}`}
    {...props}
  />
);

export const Quote = ({ className, ...props }: PProps) => (
  <p className={`${styles.quote}${className ? ` ${className}` : ''}`} {...props} />
);

export const Name = ({ className, ...props }: PProps) => (
  <p className={`${styles.name}${className ? ` ${className}` : ''}`} {...props} />
);

export const Profile = ({ className, ...props }: PProps) => (
  <p
    className={`${styles.profile}${className ? ` ${className}` : ''}`}
    {...props}
  />
);

export const DotsContainer = ({ className, ...props }: DivProps) => (
  <div
    className={`${styles.dotsContainer}${className ? ` ${className}` : ''}`}
    {...props}
  />
);

export const Dot = ({
  isActive,
  className,
  ...props
}: ButtonProps & { isActive: boolean }) => (
  <button
    className={`${styles.dot}${className ? ` ${className}` : ''}`}
    data-active={isActive ? 'true' : 'false'}
    {...props}
  />
);

export const ButtonRows = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={`${styles.buttonRows} u-hide-scrollbar${
        className ? ` ${className}` : ''
      }`}
      {...props}
    />
  ),
);
ButtonRows.displayName = 'ButtonRows';

export const ButtonTabs = ({ className, ...props }: ButtonProps) => (
  <button
    className={`${styles.buttonTabs}${className ? ` ${className}` : ''}`}
    {...props}
  />
);
